"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../utils/helpers");
var _CustomSelectModule = _interopRequireDefault(require("../../scss/form-elements/CustomSelect.module.scss"));
function ChoicesItem(_ref) {
  let {
    item,
    handleOnClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("li", {
    onClick: () => handleOnClick(item.id),
    id: item.id,
    key: item.id,
    className: (0, _helpers.classes)([item.status === 'selected' ? "".concat(_CustomSelectModule.default['custom-select__item--selected'], " custom-select__item--selected") : '', item.status === 'highlighted' ? "".concat(_CustomSelectModule.default['custom-select__item--highlighted'], " custom-select__item--highlighted") : ""])
  }, item.label);
}
var _default = exports.default = ChoicesItem;